import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { BackButton } from "src/common/components/BackButton";
import { useAccess } from "src/hooks/useAccess.hook";
import sidebarConfig from "src/layouts/dashboard/SidebarConfig";
import { alertSlice } from "src/store/alert/alert.slice";
import { FEATURE } from "src/util/enums";
import Page from "../Page";
import VehicleDetailForm from "./VehicleDetailForm";

export const Vehicle = () => {
  const navigate = useNavigate();
  const newVehicleMatch = useMatch("/vehicles/new");
  const notAuthorized = useAccess(FEATURE.VEHICLE, "N");
  const createAccess = useAccess(FEATURE.VEHICLE, "C");
  const dispatch = useDispatch();
  const [registrationNumber, setRegistrationNumber] = useState("");

  useEffect(() => {
    if ((newVehicleMatch && !createAccess) || (!newVehicleMatch && notAuthorized)) {
      dispatch(
        alertSlice.actions.setAlert({ open: true, message: "Not Authorized" })
      );
      navigate(sidebarConfig[FEATURE.VEHICLE].path);
    }
  }, [dispatch, newVehicleMatch, createAccess, navigate, notAuthorized]);

  const headerText = newVehicleMatch
    ? "Create new Vehicle"
    : registrationNumber
    ? `Vehicle — ${registrationNumber}`
    : "Vehicle Details";

  return (
    <Page>
      <BackButton text={headerText} path="/vehicles" />
      <VehicleDetailForm onVehicleLoad={setRegistrationNumber} />
    </Page>
  );
};